<template>
  <el-container>
    <el-main>
      <el-row style="margin: 5px;">
        <el-collapse style="background-color: silver;" v-model="collapseConditions">
          <el-collapse-item title="絞り込み条件" name="1">
            <el-row class="extract-cond-row">
              <el-col :span="2" class="extract-cond-label">
                カテゴリ
              </el-col>
              <category-selector
                :spanSetting="4"
                horizontal
                :size="'small'"
                :category1st="category1st"
                :category2nd="category2nd"
                :category3rd="category3rd"
                @change1st="changedCategory1st"
                @change2nd="changedCategory2nd"
                @change3rd="changedCategory3rd"
              >
              </category-selector>
            </el-row>
            <el-row class="extract-cond-row">
              <el-col :span="2" class="extract-cond-label">
                ブランド
              </el-col>
              <el-col :span="4">
                <brand-selector-core
                  v-model="brandId"
                  :category1st="category1st"
                  :size="'small'"
                  clearable
                >
                </brand-selector-core>
              </el-col>
              <el-col :span="2" class="extract-cond-label">
                <span>ステータス</span>
              </el-col>
              <el-col :span="6">
                <el-select placeholder="ステータス" v-model="status" size="small">
                  <el-option
                    v-for="status in statusOptions"
                    :key="status.id"
                    :label="status.description"
                    :value="status.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="extract-cond-row">
              <el-col :span="2"  class="extract-cond-label">
                <span>キーワード</span>
              </el-col>
              <el-col :span="6">
                <el-input type="text" v-model="keyword" size="small">
                </el-input>
              </el-col>
              <el-col :span="2" style="margin-left: 20px">
                <el-button type="primary" round @click="findItems" size="small">
                  検索
                </el-button>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-row>
      <el-row type="flex" style="margin: 5px;">
        <el-col :span="3">
          <el-dropdown @command="selectActions">
            <el-button type="success">
              アクション<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="exhibit_draft">BUYMA 下書き保存開始</el-dropdown-item>
              <el-dropdown-item command="remove_items">商品データ削除</el-dropdown-item>
              <el-dropdown-item command="copy_items">商品データコピー</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :offset="9" :span="6">
          <div style="font-size: small; margin: 5px 20px">
            {{ ((currentPage - 1) * itemCntInPage) + 1 }} / {{ totalCount }} 件
            <el-select v-model="itemCntInPage" size="mini" @change="handlePaginationChanged">
              <el-option
                v-for="item in ptnItemCntInPage"
                :key="item.value"
                :label="item.value + '件/ページ'"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <el-pagination
            :total="totalCount"
            :current-page.sync="currentPage"
            :page-size="itemCntInPage"
            layout="prev, pager, next"
            @size-change="handlePaginationChanged"
            @current-change="handlePaginationChanged"
            @prev-click="handlePaginationChanged"
            @next-click="handlePaginationChanged"
          >
          </el-pagination>
        </el-col>
      </el-row>
      <el-row>
        <el-table id="table-item-list" ref="multipleTable" :data="itemList" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="ID" prop="id" width="70" sortable>
          </el-table-column>
          <el-table-column label="ステータス" width="100" sortable>
            <template slot-scope="scope">
              <div v-if="scope.row.status === '0'">編集中</div>
              <div v-if="scope.row.status === '1'">下書き保存完了</div>
              <div v-if="scope.row.status === '2'">下書き保存エラー</div>
            </template>
          </el-table-column>
          <el-table-column label="画像" width="60">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px" :src="getImageUrl(scope.row.url)" fit="contain">
                <div slot="error" class="image-slot" style="height: 100%; background: #DDDDDD;">
                  <i class="el-icon-picture-outline" style="margin-top: 5%; font-size: 32px;"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="ブランド" prop="brand" width="250" sortable>
          </el-table-column>
          <el-table-column label="商品名" width="300" sortable>
            <template slot-scope="scope">
              <router-link :to="{ name: 'Item', params: { id: scope.row.id } }">
                {{ scope.row.name }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="価格" prop="exhibitPrice" width="100"></el-table-column>
          <el-table-column label="最終更新日時" prop="lastupdt" width="200" sortable></el-table-column>
          <el-table-column label="エラー" sortable>
            <template slot-scope="scope">
              <span v-if="(scope.row.errMsg != null) && (scope.row.errMsg.length > 0)">
                あり
              </span>
              <span v-else>
                なし
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import api from '@/http/api.js'
import CategorySelector from '@/components/CategorySelector.vue'
import BrandSelectorCore from '@/components/BrandSelectorCore.vue'

export default {
  name: 'ItemList',
  components: {
    categorySelector: CategorySelector,
    brandSelectorCore: BrandSelectorCore
  },
  data: function () {
    return {
      extractCondLabelSize: 4,
      itemList: [],
      currentPage: 1,
      itemCntInPage: 20,
      ptnItemCntInPage: [
        { value: 20 },
        { value: 50 },
        { value: 100 }
      ],
      totalCount: 0,
      selectedItems: [],
      brands: [
        { id: '00000', name: '指定なし', phonetic: '', category1st: '' }
      ],
      loadingBrands: false,
      keyword: '',
      brandId: '',
      category1st: 0,
      category2nd: 0,
      category3rd: 0,
      status: '99',
      statusOptions: [
        { id: '99', description: '指定なし' },
        { id: '0', description: '編集中' },
        { id: '1', description: '下書き保存完了' },
        { id: '2', description: '下書き保存エラー' }
      ],
      collapseConditions: ['1']
    }
  },
  mounted: function () {
    api.item.getItemsCount().then(data => {
      this.totalCount = data
    })
    api.item.getItemList('1', '20').then(data => {
      this.itemList = data.list
    })
  },
  methods: {
    getImageUrl: function (url) {
      return process.env.VUE_APP_IMG_ORIGIN + url
    },
    selectActions: function (command) {
      var ids = []
      var item = null
      if (command === 'exhibit_draft') {
        for (item of this.selectedItems) {
          ids.push(item.id)
        }
        if (ids.length > 0) {
          window.postMessage(
            {
              msg_id: 'BuyMeister_Exhibit_Request',
              ids: JSON.stringify(ids),
              token: this.$store.getters.getToken
            }
          )
        }
      } else if (command === 'remove_items') {
        this.$confirm(this.selectedItems.length + '件の商品データを削除します。\nよろしいですか', '確認',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'キャンセル',
            type: 'warning'
          }
        ).then(() => {
          for (item of this.selectedItems) {
            ids.push(item.id)
          }
          if (ids.length > 0) {
            this.removeItems(ids)
          }
        })
      } else if (command === 'copy_items') {
        this.copyItem(this.selectedItems)
      }
    },
    handleSelectionChange: function (val) {
      this.selectedItems = val
    },
    handlePaginationChanged: function () {
      var reqParam = this.createRequestParam()
      api.item.getItemList(this.currentPage, this.itemCntInPage, reqParam).then(data => {
        this.itemList = data.list
      })
    },
    removeItems: function (ids) {
      api.item.deleteItems(ids).then(data => {
        if (data.result === 'OK') {
          alert('削除完了')
          this.findItems()
        } else {
          alert('削除失敗')
        }
      }).catch(e => {
        alert('削除失敗')
      })
    },
    findItems: function () {
      var reqParam = this.createRequestParam()
      api.item.getItemsCount(reqParam).then(data => {
        this.totalCount = data
        api.item.getItemList(1, this.itemCntInPage, reqParam).then(data => {
          this.itemList = data.list
          this.currentPage = 1
        })
      })
    },
    copyItem: async function (items) {
      for (var item of items) {
        await api.item.copyItem(item.id)
      }
      this.findItems()
    },
    createRequestParam: function () {
      var reqParam = {}
      if (this.keyword !== '') {
        reqParam.name = this.keyword
      }
      if (this.brandId !== '00000' && this.brandId !== '') {
        reqParam.brand = this.brandId
      }
      if (this.category1st !== 0) {
        reqParam.id1st = this.category1st
      }
      if (this.category2nd !== 0) {
        reqParam.id2nd = this.category2nd
      }
      if (this.category3rd !== 0) {
        reqParam.id3rd = this.category3rd
      }
      if (this.status !== '99') {
        reqParam.status = this.status
      }
      return reqParam
    },
    queryBrands: function (query) {
      this.loadingBrands = true
      api.brand.getBrands(query).then(data => {
        this.brands = data
        this.loadingBrands = false
      })
    },
    changedCategory1st: function (e) {
      this.category1st = e
      this.category2nd = 0
      this.category3rd = 0
    },
    changedCategory2nd: function (e) {
      this.category2nd = e
      this.category3rd = 0
    },
    changedCategory3rd: function (e) {
      this.category3rd = e
    }
  }
}
</script>

<style scoped>
.pagination-dropdown {
  width: 200px;
}
.extract-cond-label {
  margin-top: 5px;
  margin-right: 10px;
  text-align: end;
  font-size: medium;
}
.extract-cond-row {
  margin-top: 10px;
  margin-right: 10px;
}
span.el-pagination__sizes div.el-select.el-select--mini {
  min-width: 200px;
}
</style>
